import { axiosGet, axiosPost } from "../../react_axios/Axios";
import {
  DEBIT_NOTE_DELETE_ACTION_TYPE,
  DEBIT_NOTE_DETAILS_ACTION_TYPE,
  DEBIT_NOTE_DETAILS_ORDER_ACTION_TYPE,
  DEBIT_NOTE_DOWNLOAD_ACTION_TYPE,
  DEBIT_NOTE_IE_ACTION_TYPE,
  DEBIT_NOTE_LIST_ACTION_TYPE,
  DebitNoteRPT,
  debitNoteDetailsOrderUrl,
  debitNoteDetailsUrl,
  debitNoteListUrl,
  deleteDebitNoteUrl,
  fetchReport,
  headers,
  insertEditDebitNoteUrl,
} from "../../utils/constants";
import moment from "moment";

export const debit_note_list_action =
  ( DebitNoteNo, FromDate,ToDate, CompanyName, StatusID) =>
  async (dispatch) => {
    try {
      const mapdata = {
        userId:
          sessionStorage.getItem("userId") == "" ||
          sessionStorage.getItem("userId") == null
            ? ""
            : sessionStorage.getItem("userId"),
        DebitNoteNo: DebitNoteNo.toString().trim(),
        FromDate: FromDate
          ? moment(FromDate).format("YYYY-MM-DD")
          : null,
          ToDate: ToDate
          ? moment(ToDate).format("YYYY-MM-DD")
          : null,
        CompanyName: CompanyName.toString().trim(),
        StatusID: StatusID.toString().trim(),
      };
      const params = {
        userId: mapdata.userId === "" ? null : mapdata.userId,
        DebitNoteNo: mapdata.DebitNoteNo === "" ? null : mapdata.DebitNoteNo,
        FromDate: FromDate
        ? moment(FromDate).format("YYYY-MM-DD")
        : null,
        ToDate: ToDate
        ? moment(ToDate).format("YYYY-MM-DD")
        : null,
        CompanyName: mapdata.CompanyName,
        StatusID: mapdata.StatusID,
      };
      console.log("debitNote mapdata...", mapdata);
      const res = await axiosGet(debitNoteListUrl, params,headers);
      console.log("debitNote", res);
      dispatch({
        type: DEBIT_NOTE_LIST_ACTION_TYPE,
        payload: res,
      });
      return res; // No need to wrap in Promise.resolve()
    } catch (err) {
      return Promise.reject(err);
    }
  };

export const debit_note_detail_order_action =
  (userId, OrderID) => async (dispatch) => {
    try {
      const params = {
        userId:
          sessionStorage.getItem("userId") == "" ||
          sessionStorage.getItem("userId") == null
            ? ""
            : sessionStorage.getItem("userId"),
        OrderID: OrderID,
      };
      console.log("debitNote detail mapdata...", params);
      const res = await axiosGet(debitNoteDetailsOrderUrl, params,headers);
      console.log("detailsdebitNote", res);
      dispatch({
        type: DEBIT_NOTE_DETAILS_ORDER_ACTION_TYPE,
        payload: res,
      });
      return res; // No need to wrap in Promise.resolve()
    } catch (err) {
      return Promise.reject(err);
    }
  };

export const debit_note_detail_action =
  (userId, DebitNoteID) => async (dispatch) => {
    try {
      const params = {
        userId:
          sessionStorage.getItem("userId") == "" ||
          sessionStorage.getItem("userId") == null
            ? ""
            : sessionStorage.getItem("userId"),
        DebitNoteID: DebitNoteID ? DebitNoteID.toString().trim() : "",
      };
      console.log("debitNote detail mapdata...", params);
      const res = await axiosGet(debitNoteDetailsUrl, params,headers);
      console.log("detailsdebitNote", res);
      dispatch({
        type: DEBIT_NOTE_DETAILS_ACTION_TYPE,
        payload: res,
      });
      return res; // No need to wrap in Promise.resolve()
    } catch (err) {
      return Promise.reject(err);
    }
  };

export const debit_note_add_action =
  (
    userId,
    DebitNoteID,
    DebitNoteNo,
    DebitNoteDate,
    OrderNo,
    CompanyName,
    Address,
    GSTNo,
    CurrencyID,
    Remark,
    udtList,
    OrderID,
    ClientID,PrimaryEmailID
  ) =>
  async (dispatch) => {
    try {
      const mapdata = {
        userId:
          sessionStorage.getItem("userId") == "" ||
          sessionStorage.getItem("userId") == null
            ? ""
            : sessionStorage.getItem("userId"),
            DebitNoteID:DebitNoteID?DebitNoteID:"",
        DebitNoteNo: DebitNoteNo?DebitNoteNo:"",
        DebitNoteDate:DebitNoteDate? moment(DebitNoteDate, 'DD-MM-YYYY').format('YYYY-MM-DD'):"",
        OrderNo: OrderNo ? OrderNo : "",
        CompanyName: CompanyName,
        Address: Address,
        GSTNo: GSTNo,
        CurrencyID: CurrencyID,
        Remark:Remark,
        udtList:udtList,
        OrderID: OrderID,
        ClientID:ClientID,PrimaryEmailID:PrimaryEmailID
      };
      console.log("debitNote add mapdata...", mapdata);

      const res = await axiosPost(insertEditDebitNoteUrl, mapdata, headers);
      dispatch({
        type: DEBIT_NOTE_IE_ACTION_TYPE,
        payload: res,
      });
      return Promise.resolve(res);
    } catch (err) {
      return Promise.reject(err);
    }
  };

export const debit_note_delete_action =
  ( DebitNoteID) => async (dispatch) => {
    try {
      const mapdata = {
        userId:
          sessionStorage.getItem("userId") == "" ||
          sessionStorage.getItem("userId") == null
            ? ""
            : sessionStorage.getItem("userId"),
        DebitNoteID: DebitNoteID ? DebitNoteID.toString().trim() : "",
      };

      const res = await axiosGet(deleteDebitNoteUrl, mapdata,headers);
      dispatch({
        type: DEBIT_NOTE_DELETE_ACTION_TYPE,
        payload: res,
      });
      return Promise.resolve(res);
    } catch (err) {
      return Promise.reject(err);
    }
  };
  export const download_debitNote_action = (userId, DebitNoteID,DebitNoteNo) => async (dispatch) => {
    try {
      var list = [];
      const mapdata1 = {
        ParameterName: "@DebitNoteID",
        ParameterValue: DebitNoteID,
        ParameterDataType: "int",
      };
      list.push(mapdata1);
      console.log("mapdata1", mapdata1, list);
  
      const mapData = {
        user_id: userId,
        report_name: DebitNoteRPT,
        report_file_name: DebitNoteNo,
        config_id: 0,
        parameter_details: list,
      };
      console.log(mapData);
      const res = await axiosPost(fetchReport, mapData, headers);
  
      dispatch({
        type: DEBIT_NOTE_DOWNLOAD_ACTION_TYPE,
        payload: res,
      });
  
      return Promise.resolve(res);
    } catch (err) {
      return Promise.reject(err);
    }
  };